import { createPushNotification } from "src/modules/push-notification-protobuf";

export function createTestNotification(deviceName) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "scheduledMonitoringTest",
        alert: {
          "title-loc-key":
            "babyStation.scheduledMonitoringTestNotification.title",
          "loc-key": "babyStation.scheduledMonitoringTestNotification.message",
          "loc-args": deviceName
        },
        sound: "default",
        "mutable-content": 1
      }
    },
    androidPayload: {
      type: "scheduledMonitoringTest",
      deviceName
    }
  });
}

export function createStartScheduledMonitoringNotification({
  deviceName,
  jid,
  monitoringId,
  avatarName,
  avatarSex
}) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "monitoringStartedScheduled",
        alert: {
          "title-loc-key": "parentStation.scheduledMonitoringStarted.title",
          "loc-key": "parentStation.scheduledMonitoringStarted.message",
          "loc-args": deviceName
        },
        sound: "default",
        "mutable-content": 1
      },
      jid,
      monitoringId,
      avatarName,
      avatarSex
    },
    androidPayload: {
      type: "monitoringStartedScheduled",
      jid,
      monitoringId,
      avatarName,
      avatarSex
    }
  });
}

export function createStopScheduledMonitoringNotification({
  deviceName,
  jid,
  monitoringId,
  avatarName,
  avatarSex
}) {
  return createPushNotification({
    iosPayload: {
      aps: {
        category: "monitoringStoppedScheduled",
        alert: {
          "title-loc-key": "parentStation.scheduledMonitoringStopped.title",
          "loc-key": "parentStation.scheduledMonitoringStopped.message",
          "loc-args": deviceName
        },
        sound: "default",
        "mutable-content": 1
      },
      jid,
      monitoringId,
      avatarName,
      avatarSex
    },
    androidPayload: {
      type: "monitoringStoppedScheduled",
      jid,
      monitoringId,
      avatarName,
      avatarSex
    }
  });
}
